import React from 'react';
import { Link } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Container } from '@mui/material';


const Canceled = () => {
    localStorage.removeItem('invoiceList');
    localStorage.removeItem('paymentAmount');
    localStorage.removeItem('paymentIntent');
    localStorage.removeItem('checkoutSession');
    return (
        <Container style={{padding: 100}}>
            <Card style={{width: 'min-content', minWidth: 450, margin: '0 auto'}}>
                <CardContent>
                    <Typography variant='heading1'>Your payment was cancelled</Typography>
                </CardContent>
                <CardActions>
                    <Button variant='outlined' color='primary' href='/invoices' style={{margin: '0 auto'}}>Return</Button>
                </CardActions>
            </Card>
        </Container>
    );
};


export default Canceled;
